import { IAngularEvent, IComponentOptions, IController } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IPlanningSession } from "../../../sessions/models/models";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { IGoal } from "@gtmhub/goals/models";
import { IStatusBarRootScope, StatusBarService } from "./status-bar.service";
import { IMetric } from "@gtmhub/okrs/metrics";
import { MethodType } from "@gtmhub/goals/controllers/clone-or-move-goal";

type StatusType = "done_cloning_metric" | "starting" | "in_progress" | "cloning" | "moving_done" | "done" | "error";
export interface IStatusData {
  status: StatusType;
  action?: MethodType;
  params?: ICloningMetricParams | ICloningOrMovingGoalParams | ICloningSessionOkrsParams;
}

interface ICloningMetricParams {
  targetGoal: IGoal;
  metric: IMetric;
}

export interface ICloningOrMovingGoalParams extends ISessionOkrsAndOkrCloningParams {
  goal: IGoal;
  targetGoal?: IGoal;
  targetSession?: IPlanningSession;
}

export interface ICloningSessionOkrsParams extends ISessionOkrsAndOkrCloningParams {
  isSessionClone?: boolean;
  targetSession: IPlanningSession;
}

export interface ISessionOkrsAndOkrCloningParams {
  totalItemsCounter?: number;
  includeItems?: boolean;
}

export class StatusBarCtrl implements IController {
  indicators: { inProgress: boolean };
  displayError: boolean;
  private rollback = false;

  //data
  status: StatusType;
  action: MethodType;
  data: Partial<ICloningMetricParams | ICloningOrMovingGoalParams | ICloningSessionOkrsParams>;

  static $inject = ["$rootScope", "$state", "StatusBarService"];

  constructor(private $rootScope: IStatusBarRootScope & ITraceRootScopeService, private $state: StateService, private statusBarService: StatusBarService) {
    this.indicators = {
      inProgress: true,
    };
  }

  $onInit(): void {
    this.$rootScope.$on("updateStatusBarData", this.updateStatusBarData);
  }

  close(): void {
    this.statusBarService.hide();
  }

  openSession(id: string): void {
    this.$state.go("gtmhub.goals.all", { planningSessionId: id });
    this.close();
  }

  openObjective(goal: IGoal): void {
    this.$state.go("gtmhub.goals.all._goalSidebar.goal", { id: goal.id, planningSessionId: goal.sessionId });
    this.close();
  }

  openMetric(metric: IMetric): void {
    this.$state.go("gtmhub.goals.all._metric.metric", { metricId: metric.id, planningSessionId: metric.sessionId });
    this.close();
  }

  private updateStatusBarData = (ev: IAngularEvent, data: IStatusData): void => {
    this.data = data.params || {};

    switch (data.status) {
      case "error":
        {
          this.displayError = true;
          this.action = data.action;
          this.updateUIAfterOneSecond(data);
          this.rollbackItems();
        }
        break;
      case "done":
      case "done_cloning_metric":
        {
          if (this.rollback) {
            return;
          }
          this.updateUIAfterOneSecond(data);
        }
        break;
      default:
        this.status = data.status;
        this.action = data.action;
        break;
    }
  };

  private updateUIAfterOneSecond = (data: IStatusData) => {
    // some actions take less than 1 second to perform, so we need setTimeout to have smoother transitions between displayed statuses
    setTimeout(() => {
      this.$rootScope.$broadcast("goalsChanged");
      this.$rootScope.cloningMovingInProgress = false;
      this.status = data.status;
      this.action = data.action;
    }, 1000);
  };

  private rollbackItems(): void {
    this.$rootScope.traceAction("rollback_cloned_items", () => {
      this.$rootScope.$broadcast("rollback");
      this.rollback = true;
    });
  }
}

export const StatusBarComponent: IComponentOptions = {
  controller: StatusBarCtrl,
  templateUrl: require("./status-bar.jade"),
};
